import { render, staticRenderFns } from "./workResumption.vue?vue&type=template&id=2633c1cd&scoped=true"
import script from "./workResumption.vue?vue&type=script&lang=js"
export * from "./workResumption.vue?vue&type=script&lang=js"
import style0 from "./workResumption.vue?vue&type=style&index=0&id=2633c1cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633c1cd",
  null
  
)

export default component.exports